import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Col, Form } from "react-bootstrap";
import VehicleInfoViewModel from "viewModels/common/vehicleInfoViewModel";
import AsyncSelect from "controls/asyncSelect";
import { DataTestIds } from "data-test-constants";
import countryFilter from "@edaz/utils/countryFilter";

const CountryIdInput: FunctionComponent<{
  vm: VehicleInfoViewModel;
  disabled?: boolean;
  translateKey?: string;
  breakpoint?: "xl" | "xxl";
  errorMessage?: string;
  labelId?: string;
}> = observer(({ vm, disabled, translateKey, breakpoint, errorMessage, labelId = "country-label" }) => {
  const ta = (code: string) =>
    vm.localizationService.translateAttribute(translateKey ? `orderItem.${translateKey}` : "orderItem", code);

  return (
    <Form.Group as={Col} sm={12} className={breakpoint === "xxl" ? "col-xxl-9" : "col-xl-6"}>
      <Form.Label id={labelId}>{ta("countryId")}</Form.Label>
      {disabled ? (
        <Input data-testid={DataTestIds.DISABLED_COUNTRY_SELECT} disabled={true} target={vm} property={"oldCountry"} />
      ) : (
        <AsyncSelect
          id={DataTestIds.COUNTRY_SELECT}
          aria-labelledby={labelId}
          data-testid={DataTestIds.COUNTRY_SELECT}
          target={vm.item}
          property="countryId"
          loadOptionsOnInit={vm.loadCountriesOnInit}
          defaultOptions={vm.defaultCountries}
          loadOptions={vm.loadCountries}
          errorMessage={errorMessage}
          placeholder={vm.localizationService.translateGeneral("common.selectCountry")}
          mode="key"
          filterOption={countryFilter}
        />
      )}
    </Form.Group>
  );
});

export default CountryIdInput;
